import { multiSelectOptions } from '@/components/ui/multi-select-utils';
import { timezoneZodSchema } from '@/lib/time-zones';
import type { CreateUserOptions } from '@airreading/common/data';
import { z } from 'zod';

export const createUserCommonFormSchema = z.object({
  firstName: z.string().min(1, { message: 'First name is required' }),
  lastName: z.string().optional().nullable().default(null),
  email: z.string().email({ message: 'Invalid email' }),
  phone: z.string().optional().nullable().default(null),
  timeZone: timezoneZodSchema.optional(),
  edlinkId: z.string().optional().nullable().default(null),
});
export type CreateUserCommonFormSchema = z.infer<typeof createUserCommonFormSchema>;

export function createUserOptionsFromFormData({
  firstName,
  lastName,
  email,
  phone,
  timeZone,
  edlinkId,
}: CreateUserCommonFormSchema): CreateUserOptions {
  return {
    firstName,
    lastName,
    email,
    phone,
    assignRoles: [],
    timeZone: timeZone?.value || null,
    edlinkId: edlinkId?.trim() || null,
  };
}

export const nonCoreUserRolesFormSchema = z.object({
  // isOrgAdmin: z.boolean().default(false),
  // adminOrgs: z.array(multiSelectZodOptionSchema),

  isSchoolAdmin: z.boolean().default(false),
  adminSchools: multiSelectOptions.default([]),

  isSchoolContact: z.boolean().default(false),
  contactSchools: multiSelectOptions.default([]),
});

export type NonCoreUserRolesFormSchema = z.infer<typeof nonCoreUserRolesFormSchema>;

export const editBasicInfoFormSchema = z.object({
  firstName: z.string({ required_error: 'First name is required' }).trim(),
  lastName: z.string({ required_error: 'Last name is required' }).trim(),
  email: z.string().trim().min(1, 'Email is required').email({ message: 'Invalid email format' }),
  phone: z.string().trim().optional().nullable().default(null),
  timeZone: timezoneZodSchema,
  edlinkId: z.string().optional().nullable().default(null),
});
export type EditBasicInfoForm = z.infer<typeof editBasicInfoFormSchema>;
